module.exports = __webpack_public_path__ + "static/media/server.e83387a8.png";